import { Box, Button } from "@mui/material";

import DropdownButton from "components/DropdownButton";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

function Navbar() {
  const navigate = useNavigate();

  const portfolioBasketMenu = useSelector(
    (state) => state.wallet.portfolioBasketMenu?.data
  );

  const tradeItems = [
    {
      name: "Basic Trade",
      onClick: () => navigate("/trade/1/3"),
    },
    {
      name: "Advanced Trade",
      onClick: () => navigate("/advanced-trade/1/3"),
    },
  ];

  const walletItems = useMemo(() => {
    const result = [];

    portfolioBasketMenu?.forEach((p) => {
      if (p?.isHavePortfolio) {
        const navigateLink = `/wallet/portfolio/${p?.portfolioId}`;

        result.push({
          key: p?.portfolioId,
          name: p?.name,
          path: navigateLink,
          onClick: () => navigate(navigateLink),
          children: [],
        });
      }
    });

    portfolioBasketMenu?.forEach((basketMenu) => {
      const isBasket = basketMenu?.isHaveBasket;
      const navigateLink = `/wallet/basket/${basketMenu?.basketId}/${basketMenu?.portfolioId}`;

      if (isBasket) {
        const portfolioIndex = result.findIndex(
          (basket) => basket?.key === basketMenu?.portfolioId
        );

        if (portfolioIndex !== -1 && result?.[portfolioIndex]?.children) {
          result?.[portfolioIndex].children?.push({
            key: basketMenu?.id,
            name: basketMenu?.name,
            path: navigateLink,
            onClick: () => navigate(navigateLink),
          });
        } else {
          result.push({
            key: basketMenu?.id,
            name: basketMenu?.name,
            path: navigateLink,
            children: [],
            onClick: () => navigate(navigateLink),
          });
        }
      }
    });

    return [
      {
        name: "Portfolio",
        onClick: () => navigate("/portfolio"),
      },
      ...result,
    ];

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [portfolioBasketMenu]);

  const historyItems = [
    {
      name: "Trade History",
      onClick: () =>
        navigate("/history/trade-history?tradeTab=1"),
    },
    {
      name: "Order History",
      onClick: () =>
        navigate("/history/trade-history?tradeTab=0"),
    },
    {
      name: "Borrow",
      onClick: () =>
        navigate("/history/basket-history?typeId=2"),
    },
    {
      name: "Repayment",
      onClick: () =>
        navigate("/history/basket-history?typeId=3"),
    },
    {
      name: "Interest",
      onClick: () =>
        navigate("/history/basket-history?typeId=4"),
    },
  ];

  return (
    <Box>
      <Button variant="text" color="text" onClick={() => navigate("/market")}>
        Market
      </Button>

      <DropdownButton variant="text" color="text" items={tradeItems}>
        Trade
      </DropdownButton>

      <DropdownButton variant="text" color="text" items={walletItems}>
        Wallet
      </DropdownButton>

      <DropdownButton variant="text" color="text" items={historyItems}>
        History
      </DropdownButton>
    </Box>
  );
}

export default Navbar;
